// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "scripts/elements/cases" + ".js?id=" + "48a7cda4343263915681" + "";
};